<template>
  <div class="page-template">
    <!--条件搜索-->
    <div class="page-title">
      {{title}}
    </div>
    <div class="page-edit">
      <form-template ref="formTemplate" @submit="upgradePwd">
      </form-template>
    </div>
  </div>
</template>

<script>

  import formTemplate from '@/components/template/formTemplate'
  import api from '@/config/api';
  import qs from 'qs'

  export default {
    components: {
      formTemplate
    },
    data () {
      return {
        title: '修改密码',
        dialogVisibility: false,
        // 高级搜索条件
        addColumns: {
          formType: 'add',
          labelWidth: '120px',
          span: 12,
          columns: [
            {
              label: '旧密码',
              type: 'password',
              prop: 'oldPassword',
            },
            {
              label: '新密码',
              type: 'password',
              prop: 'newPassword',
              rule: [
                {required: true, message: '请输入密码', trigger: 'blur'},
                {
                  min: 6,
                  max: 20,
                  message: '长度在6到 20个字符',
                  trigger: 'blur'
                }
              ]
            },
            {
              label: '确认密码',
              type: 'repassword',
              prop: 'repassword',
              passwordProp: 'newPassword'
            }
          ],
        }
      };
    },

    mounted () {
      this.$refs['formTemplate'] && this.$refs['formTemplate'].initData(this.addColumns);
    },
    methods: {
      upgradePwd (data) {
        console.log(data)
        let loginUser = this.$utils.getSysUser();
        let params = {
          id: loginUser.id,
          newPassword: this.$utils.md5(data.newPassword)
        }
        console.log(params)
        this.$axios.fetchPost(api.system.upgradePwd, qs.stringify(params), {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'}).then(result => {
          if (result.code == 200) {
            this.$notify({
              type: "success",
              title: '修改操作',
              message: '成功',
              showClose: false,
            });
            // this.$message({type: 'success', message: '修改成功!'});
          } else {
            this.$notify({
              type: "error",
              title: '修改操作',
              message: '失败',
              showClose: false,
            });
            // this.$message({type: 'error', message: result.msg});
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/page/system/user/UpgradePwd.vue